export const META_PIXEL_ID = '2100786177979954';

type PixelEvent = 'PageView' | 'ViewContent' | 'InitiateCheckout' | 'Purchase' | 'Lead';

type PixelPayload = Record<string, string | number | boolean>;

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { queue?: unknown[]; callMethod?: (...args: unknown[]) => void };
    _fbq?: unknown;
  }
}

/** Inyecta el script base del Pixel de Meta y dispara el PageView inicial. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return;
  if (window.fbq) {
    window.fbq('track', 'PageView');
    return;
  }

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    const instance = window.fbq;
    if (!instance) return;
    if (instance.callMethod) {
      instance.callMethod(...args);
    } else {
      instance.queue = instance.queue || [];
      instance.queue.push(args);
    }
  } as NonNullable<Window['fbq']>;

  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  const pixelImage = document.createElement('img');
  pixelImage.height = 1;
  pixelImage.width = 1;
  pixelImage.style.display = 'none';
  pixelImage.alt = '';
  pixelImage.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
  noscript.appendChild(pixelImage);
  document.head.appendChild(noscript);

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** Dispara un evento estándar del Pixel de Meta. */
export function trackPixelEvent(event: PixelEvent, payload?: PixelPayload): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, payload);
}
